<template lang="pug">
  ods-main-header(
    headerLogoText="Ecosystems B2B"
    logoUrl="#"
    breadcrumbSeparator=">"
    :userMenuText="userMenuText"
    :showBreadcrumbs="canViewMenu || canAdminIndra"
    :environment="env"
    :showUserMenu="true"
    :forceAppHasNavigation="true")
    template(slot="user")
      user-menu
    template(slot="clientLogo")
      change-password-user-dialog(
        :showDialog="this.activeUser.data.changePassword"
        :showCloseDialog=false
      )
      div.ods-main-header__client-logo
        img(
          v-if='withProjectLogo'
          :src="urlLogo"
          alt="logo")
</template>

<script>
import { mapGetters } from 'vuex'
import UserMenu from '@/components/header/UserMenu'
import ChangePasswordUserDialog from '@/views/administracion/usuarios/ChangePasswordUserDialog'

export default {
  name: 'HeaderContent',
  components: {
    UserMenu,
    ChangePasswordUserDialog
  },
  computed: {
    ...mapGetters([
      'activeUser',
      'loadmenulogo',
      'canAdminIndra',
      'canViewMenu'
    ]),
    userMenuText () {
      if (this.activeUser.data) {
        const name = this.activeUser.data.name ? this.activeUser.data.name : (this.activeUser.data.username ? this.activeUser.data.username : '')
        const firstSurname = this.activeUser.data.firstSurname ? this.activeUser.data.firstSurname : ''
        const secondSurname = this.activeUser.data.secondSurname ? this.activeUser.data.secondSurname : ''
        return name + ' ' + firstSurname + ' ' + secondSurname
      } else {
        return ''
      }
    },
    withProjectLogo () {
      if (
        (this.activeUser.data && this.activeUser.data.projects && this.activeUser.data.projects.length &&
        this.activeUser.data.projects.length === 1 && this.activeUser.data.projects[0].personalization &&
        this.activeUser.data.projects[0].personalization.logo) || (this.loadmenulogo && this.loadmenulogo !== null)) {
        return true
      }
      return false
    },
    urlLogo () {
      if (this.withProjectLogo) {
        if (this.loadmenulogo && this.loadmenulogo !== null) {
          return require('@/assets/images/projects/' + this.loadmenulogo)
        } else {
          return require('@/assets/images/projects/' + this.activeUser.data.projects[0].personalization.logo)
        }
      } else {
        return ''
      }
    },
    env () {
      if (this.canAdminIndra) {
        return process.env.VUE_APP_ENV_TAG
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ods-main-header {
  &__client-logo {
    img {
      height: rem(36);
    }
  }
}
 // COLORES DE LA ETIQUETA DE ENTONO
::v-deep .ods-main-header__environment .ods-tag.dev {
  background-color: #008000 !important;
  border-color:  #008000 !important;
  padding: 10px;
  text-transform: uppercase;
}
::v-deep .ods-main-header__environment .ods-tag.pre {
    padding: 10px;
    text-transform: uppercase;
}

</style>
